import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { func, arrayOf, string, object } from 'prop-types';
import { searchState } from 'utils';
import { SortItemMobile } from './components';
import './SortingBar.scss';

const message = defineMessages({
    sortingTitle: {
        id: 'listing.sorting.title',
        defaultMessage: 'Sort',
        description: 'Sort label of the sorting button',
    },
});
export default function SortingBar({
    currentRefinement,
    onClick,
    groupedIndexes,
}) {
    const intl = useIntl();
    return (
        <label className="sorting-bar" htmlFor="listing-sort-selector">
            {intl.formatMessage(message.sortingTitle)}
            <svg className="sorting-bar__caret" viewBox="0 0 10 6">
                <path d="m1,1 4,4 4,-4" />
            </svg>
            <select
                onChange={onClick}
                id="listing-sort-selector"
                data-sort="mobileSorting"
                className="sorting-bar__select"
            >
                {groupedIndexes.map(({ value, label }) => (
                    <SortItemMobile
                        key={label}
                        value={value}
                        label={label}
                        isRefine={searchState.isRefined(
                            value,
                            currentRefinement,
                        )}
                    />
                ))}
            </select>
        </label>
    );
}

SortingBar.propTypes = {
    currentRefinement: string.isRequired,
    onClick: func.isRequired,
    groupedIndexes: arrayOf(object).isRequired,
};
